import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=41a27aca&scoped=true&"
import script from "./notfound.vue?vue&type=script&lang=js&"
export * from "./notfound.vue?vue&type=script&lang=js&"
import style0 from "./notfound.vue?vue&type=style&index=0&id=41a27aca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a27aca",
  null
  
)

export default component.exports